import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shifts: [],
  currentShift: null,
  loading: false,
  error: null,
  filters: {
    companyId: '',
    isActive: true,
    search: '',
  },
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
};

const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {
    setShifts: (state, action) => {
      state.shifts = action.payload.data || action.payload || [];
      state.pagination = {
        ...state.pagination,
        total: action.payload.total || action.payload.pagination?.total || 0,
        pages: action.payload.pages || action.payload.pagination?.pages || 1,
        page: action.payload.page || action.payload.pagination?.page || 1,
        limit: action.payload.limit || action.payload.pagination?.limit || 10,
      };
    },
    setCurrentShift: (state, action) => {
      state.currentShift = action.payload;
    },
    addShift: (state, action) => {
      state.shifts.push(action.payload);
    },
    updateShift: (state, action) => {
      const index = state.shifts.findIndex(shift => shift._id === action.payload._id);
      if (index !== -1) {
        state.shifts[index] = action.payload;
      }
    },
    removeShift: (state, action) => {
      state.shifts = state.shifts.filter(shift => shift._id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
    resetShiftState: () => initialState,
  },
});

export const {
  setShifts,
  setCurrentShift,
  addShift,
  updateShift,
  removeShift,
  setLoading,
  setError,
  setFilters,
  setPagination,
  clearFilters,
  resetShiftState,
} = shiftSlice.actions;

export default shiftSlice.reducer;
